import React from "react";
import { useSelector } from "react-redux";
import OrdersTab from "../OrdersTab/OrdersTab";
import AnalyzeButton from "../../components/AnalyzeButton/AnalyzeButton";
import { ABAS, TABS } from "../../config/tabs";
import { sendGaEvent } from "../../../../../main/sendGaEvent";



const ALERT = {
  severity: "warning",
  message:
    "Recebemos a confirmação de entrega para os pedidos abaixo. Confira e marque como coletado os pedidos que saíram da loja.",
};

export default function LateCollectionPage(props) {
  const count = useSelector((state) => {
    const grid = state.orders.grids["ready-to-go"] || {};
    return (grid.counts || {}).coletaTardia;
  });


  const handleAnalyzeClick = (pedido, onAnalyze) => {
    sendGaEvent("analyze_collection", "ready-to-go", {
      tab: TABS.COLETA_TARDIA,
      sales_channel: pedido.canalDeVendas,
      order_id: pedido.codigoExterno,
      order_count: count,
      origin: "lista-coleta-tardia",
    });

    onAnalyze(pedido);
  };

  const handleAnalyzeConfirm = (option, pedido) => {
    sendGaEvent("analyze_collection_confirm", "ready-to-go", {
      tab: TABS.COLETA_TARDIA,
      sales_channel: pedido && pedido.canalDeVendas,
      order_id: pedido && pedido.codigoExterno,
      option,
      origin: "modal-analisar-coleta",
    });
  };

  return (
    <OrdersTab
      {...props}
      alert={ALERT}
      aba={ABAS.COLETA_TARDIA}
      gaTab={TABS.COLETA_TARDIA}
      gaCountKey="coletaTardia"
      onAnalyzeConfirm={handleAnalyzeConfirm}
      renderActions={(pedido, ctx) => (
        <AnalyzeButton
          onClick={() => handleAnalyzeClick(pedido, ctx.onAnalyze)}
        />
      )}
    />
  );
}
